module.exports = __webpack_public_path__ + "static/img/manual-8.f1e350c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/manual-8.png
// module id = 0idd
// module chunks = 4